export const en = {
    "en": "English",
    "zh": "Chinese",
    "Language": "Language",
    "Text": "Text",
    "Required": "Please enter {0}.",
    "Required1": "Please enter {0} {1}.",
    "Minlength": "The {0} is too short.",
    "Minlength1": "The {0} {1} is too short.",
    "Minlength2": "The {0} must be at least {1} characters long.",
    "Minlength3": "The {0} {1} must be at least {2} characters long."

}